// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import {
    Avatar,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";



// main function
export default function SubmittedContractAvatar({ rowContractData }) {


    return (

        <Box>
            {
                (rowContractData.comboStatus === 's')
                &&
                <div>
                    <Tooltip
                        enterDelay={1000}
                        title="SubmittedContractAvatar"
                    >
                    <Avatar sx={{height: 20, width: 20, fontSize: 14, bgcolor: '#424242'}}>s
                    </Avatar>
                    </Tooltip>
                </div>}
        </Box>

    )

}
